import api from "./api"


export const getPurchaseReceiptFormData = async () => {
  const response = await api.get("/purchase-receipts/form-data")
  return response.data
}


export const getPurchaseReceipts = async (params = {}) => {
  const response = await api.get("/purchase-receipts", {
    params,
  })

  return response.data
}


export const getPurchaseReceiptById = async (receiptId) => {
  const response = await api.get(
    `/purchase-receipts/${receiptId}`
  )

  return response.data
}


/**
 * Charge spécifiquement le bon sélectionné
 * avec ses lignes encore réceptionnables.
 *
 * C'est préférable à dépendre uniquement du form-data :
 * - les quantités restent à jour ;
 * - les réceptions partielles sont correctement recalculées ;
 * - les anciens PO incomplets peuvent être réparés côté backend.
 */
export const getPurchaseOrderReceiptItems = async (
  purchaseOrderId
) => {
  const response = await api.get(
    `/purchase-receipts/purchase-order/${purchaseOrderId}/items`
  )

  return response.data
}


export const createPurchaseReceipt = async (payload) => {
  const response = await api.post(
    "/purchase-receipts",
    payload
  )

  return response.data
}


export const controlPurchaseReceipt = async (
  receiptId,
  payload = {}
) => {
  const response = await api.post(
    `/purchase-receipts/${receiptId}/control`,
    payload
  )

  return response.data
}